/*
 * Copyright (c) 2017-2026 Brighter AI Technologies GmbH. All rights reserved.
 * Unauthorized use, copying, reproduction, or distribution of this file, via any medium,
 * is strictly prohibited.
 */

import * as React from "react";
import { useTheme } from "@material-ui/core/styles";

const Logo = (props) => {
  const theme = useTheme();
  return (
    <svg width="214.5" height="40" viewBox="0 10 214.5 10" {...props}>
      <g
        aria-label="brighter AI"
        style={{
          lineHeight: 1.25,
        }}
        fontWeight={400}
        fontSize={7.056}
        fontFamily="Permanent Marker"
        letterSpacing={0}
        wordSpacing={0}
        strokeWidth={0.265}
        fill={theme.palette.secondary.light}
      >
        <path
          style={{
            fill: "white",
          }}
          id="svg_3"
          d="m10.2,6.1c-2.9,0 -4.9,1.2 -6.1,3.2l0,-9.3l-4.1,0l0,23.4l4.1,0l0,-2.7c1.1,2 3.1,3.2 6.1,3.2c5.4,0 7.7,-4 7.7,-8.9c0,-4.8 -2.3,-8.9 -7.7,-8.9zm-1.1,14.5c-3.3,0 -4.9,-1.8 -4.9,-5.6c0,-3.8 1.6,-5.6 4.9,-5.6c3.4,0 4.7,1.8 4.7,5.6c0,3.8 -1.3,5.6 -4.7,5.6zm16.2,-10.1l0,-3.9l-4,0l0,16.8l4.1,0l0,-6.5c0,-4.1 1.1,-6.5 5,-6.5l1.2,0l0,-4l-0.8,0c-2.9,0 -4.6,1.7 -5.5,4.1zm9.5,12.9l4.1,0l0,-16.7l-4.1,0l0,16.7zm-3.1,-19.1l10.5,0l0,-3.2l-10.5,0l0,3.2zm25,4.8c-1.1,-1.8 -3,-2.9 -5.9,-2.9c-5.4,0 -7.8,3.6 -7.8,8.3c0,4.7 2.4,8.3 7.8,8.3c2.9,0 4.8,-1 5.9,-2.8l0,3.1c0,3 -1.4,4.1 -4.7,4.1c-3,0 -4.4,-1.2 -4.6,-3.2l-4.1,0c0.3,3.9 3.2,6.2 8.5,6.2c6.5,0 9,-2.6 9,-7.4l0,-16.1l-4.1,0l0,2.4zm-4.7,10.7c-3.4,0 -4.9,-1.4 -4.9,-5.2c0,-3.8 1.4,-5.2 4.9,-5.2c3.3,0 4.7,1.6 4.7,5.2c0,3.6 -1.5,5.2 -4.7,5.2zm23,-13.7c-3.1,0 -5,1.7 -6,4.1l0,-10.2l-4.1,0l0,23.4l4.1,0l0,-7.3c0,-4.6 1.6,-6.5 4.6,-6.5c2.1,0 3.4,0.9 3.4,4l0,9.8l4.1,0l0,-10.4c0.1,-4.3 -1.6,-6.9 -6.1,-6.9zm15.5,-3.3l-2.1,0l-1.7,3.7l-3.4,1.3l0,2l3.1,0l0,8.1c0,3.7 1.2,5.5 5.6,5.5l3.2,0l0,-3.3l-4.7,0l0,-10.3l5.1,0l0,-3.1l-5.1,0l0,-3.9zm24.4,12c0,-4.7 -2.6,-8.7 -8.4,-8.7c-5.9,0 -8.7,4 -8.7,8.8c0,4.8 2.5,8.9 8.7,8.9c5.9,0 7.9,-3.1 8.3,-5.6l-3.9,0c-0.5,1.5 -1.7,2.6 -4.3,2.6c-2.6,0 -4.5,-1.1 -4.8,-4.8l12.9,0c0.2,-0.3 0.2,-0.7 0.2,-1.2zm-12.9,-1.4c0.4,-3.3 2.1,-4.3 4.7,-4.3c2.7,0 4.2,1.4 4.3,4.3l-9,0zm20.6,-2.9l0,-3.9l-4,0l0,16.8l4.1,0l0,-6.5c0,-4.1 1.1,-6.5 5,-6.5l1.2,0l0,-4l-0.8,0c-2.9,0 -4.6,1.7 -5.5,4.1zm18.8,-9.3l-8,22.2l4.3,0l1.8,-4.9l10.4,0l1.8,4.9l4.3,0l-8,-22.2l-6.6,0zm-0.7,13.9l4,-11l4,11l-8,0zm29.4,-10.8l0,-3.2l-11.4,0l0,3.2l3.6,0l0,15.7l-3.6,0l0,3.4l11.4,0l0,-3.3l-3.6,0l0,-15.8l3.6,0z"
        />
      </g>
    </svg>
  );
};

export default Logo;
